<!-- 公开咨询页面 -->
<template>
    <div class="offline-qa" @click.capture="(e) => checkAuthentice(e, {isMtCheck: true})">
        <section v-show="!isShowWriteAnswer">
            <!-- 数据指标 -->
            <div class="indicators box">
                <div class="main-title">
                    <div>公开咨询</div>
                    <!-- eslint-disable -->
                    <div class="tip" ref="mainTitleTip">
                    <!-- eslint-disable -->
                        <img
                            class="icon"
                            src="../../../assets/img/law/question.svg"
                        />
                    </div>
                    <veui-popover
                        v-if="userRole === 0"
                        target="mainTitleTip"
                    >
                        公开咨询是面向律临会员提供的专属权益，非会员可任意开通启航/精英/尊享会员后享受该权益。</br>
                        通过回答用户的提问，可以获得与用户电话联系的机会，每个提问用户可被联系的次数有限制，先回答者优先获得联系机会。</br>
                    </veui-popover>
                    <veui-popover
                        v-if="userRole === 2"
                        target="mainTitleTip"
                    >
                        公开咨询是面向律临会员提供的专属权益，非会员需开通会员后享受。</br>
                        通过回答用户的提问，可以获得与用户电话联系的机会，每个提问用户可被联系的次数有限制，先回答者优先获得联系机会。</br>
                    </veui-popover>
                    <div 
                        v-if="userRole === 0 && consumeType === '0' && !vipInfo.is_old_vip && vipInfo.vipStatusName !== ''" 
                        class="vip-notification"
                    >{{textMap[vipInfo.vipStatusName] || ''}}，更多权益可查看<span :style="{'cursor': 'pointer'}" @click="goto('lawservice')">「会员权益说明」</span>
                    </div>
                    <div 
                        v-if="userRole === 0 && consumeType === '1'" 
                        class="vip-notification"
                    >您已被授权线索使用，可享至尊会员线索无限认领权益</span>
                    </div>
                    <div 
                        v-if="userRole === 2 && firmVip" 
                        class="vip-notification"
                    >您已被授权线索使用，可享至尊会员线索无限认领权益</span>
                    </div>
                    <div
                        v-if="userRole === 0 && hasBusinessOffqrAuth"
                        class="clue-select"
                    >
                        <span class="clue-select-text"><img class="prompt" src="https://lvlin-base.cdn.bcebos.com/fe-saas/common/prompt.png">律所已授权，可切换使用</span>
                        <veui-select
                            v-model="consume"
                            :options="consumeOptions"
                            class="select"
                            @change="changeConsumeType"
                        />
                    </div>
                    <div v-if="isFirm" class="vip-set" @click="goVipSet">权益授权管理</div>
                </div>
                <div class="indicators-wrap">
                    <div
                        class="item"
                        v-for="item, index in indicatorsData"
                        :key="index"
                    >
                        <div>
                            <div class="title">
                            <div>{{ item.title }}</div>
                            <template v-if="item.tipContent && userRole === 0">
                                <!-- eslint-disable -->
                                <div class="tip" :ref="'titleTip' + index">
                                <!-- eslint-disable -->
                                    <img
                                        class="icon"
                                        src="../../../assets/img/law/question.svg"
                                    />
                                </div>
                                <veui-popover
                                    :target="'titleTip' + index"
                                >
                                    {{ item.tipContent }}
                                </veui-popover>
                            </template>
                            <template v-if="item.firmTipContent && userRole === 2">
                                <!-- eslint-disable -->
                                <div class="tip" :ref="'titleTip' + index">
                                <!-- eslint-disable -->
                                    <img
                                        class="icon"
                                        src="../../../assets/img/law/question.svg"
                                    />
                                </div>
                                <veui-popover
                                    :target="'titleTip' + index"
                                >
                                    {{ item.firmTipContent }}
                                </veui-popover>
                            </template>
                        </div>
                        <div v-if="item.num" class="num">{{ userView === '2' ? item.num['business_num'] : item.num['person_num'] }}</div>
                        </div>
                    </div>
                </div>
                <!-- 免费体验会员 banner -->
                <freeVipBanner
                    v-if="authenticationStatus === 7 && lawyerInfo && lawyerInfo.crm_enter_type === 2"
                    free-vip-words="去了解正式会员公开咨询抢答等11项专属权益吧"
                    sub-title="海量网友法律问答等你回答，获取与客户零距离沟通的机会，体验期内无限次回答"
                    expired-content="免费体验会员已到期，正式会员尊享公开咨询抢答等11项专属权益，快去了解吧"
                />
            </div>
            <!-- 表格 -->
            <div class="content box">
                <veui-tabs
                    ui="l"
                    :active="curTab"
                    @change="tabChange"
                >
                    <veui-tab
                        label="本地咨询"
                        name="localQues"
                    />
                    <veui-tab label="全国咨询" name="nationalQues">
                        <template #label="{ label, active }">
                            {{ label }}
                            <div class="tip" ref="national-tip">
                            <!-- eslint-disable -->
                                <img
                                    class="icon"
                                    src="../../../assets/img/law/question.svg"
                                />
                            </div>
                            <veui-tooltip
                                target="national-tip"
                                position="top"
                                overlay-class="update-tooltip"
                            >全国咨询展示本地以外的公开咨询</veui-tooltip>
                        </template>
                    </veui-tab>
                    <veui-tab
                        label="已被领满"
                        name="isMax"
                    />
                    <veui-tab
                        v-if="+userRole === 0"
                        label="我的回答"
                        name="myAnswer"
                    />
                    <veui-tab
                        v-if="+userRole === 2"
                        label="已回答"
                        name="myAnswer"
                    />
                </veui-tabs>
                <section>
                    <search-form
                        v-if="indicatorsData.length > 0 && indicatorsData[0].num"
                        ref="search-form"
                        :cur-tab="curTab"
                        :city-name="cityName"
                        :area-options="areaOptions"
                        :lawyerDomains="showDomain"
                        @submit="handleSubmit"
                    />
                </section>
                <section class="table-section">
                    <div
                        v-if="curTab === 'myAnswer'"
                        class="export-btn"
                        @click="exportOpen = true"
                    ><div class="export-icon"></div>导出数据</div>
                    <veui-dialog
                        title="导出数据"
                        :open.sync="exportOpen"
                        overlay-class="export-dialog"
                        @ok="handleExport"
                        @cancel="handleCancel"
                    >
                        <h4>请选择需要导出数据的时间范围</h4>
                        <veui-date-picker
                            v-model="exportDateRange"
                            range
                            clearable
                            :disabled-date="checkDateDisable"
                        ></veui-date-picker>
                    </veui-dialog>
                    <veui-table
                        :data="tableData"
                        class="table"
                        role="columnheader"
                        :loading-options="{ type: 'spinner', modal: true }"
                        :scroll="{x: 1104}"
                        :loading="isLoading"
                    >
                        <veui-table-column
                            field="question"
                            title="咨询内容"
                            class="question"
                            width="344"
                        >
                            <template #default="{question, is_masked, clue_collect_time}">
                                <overflow-tooltip overflowClass="title" overflow="y" :date="clue_collect_time" :isMasked="+is_masked === 1">{{question}}</overflow-tooltip>
                            </template>
                        </veui-table-column>
                        <veui-table-column
                            field="clue_city"
                            title="城市"
                            class="city"
                            width="160"
                        >
                            <template #default="{clue_city, is_masked}">
                                <div :class="+is_masked === 1 ? 'mask' : ''">{{ clue_city || '--' }}
                                </div>
                            </template>
                        </veui-table-column>
                        <veui-table-column
                            v-if="curTab === 'myAnswer'"
                            field="intention_status"
                            title="标记状态"
                            width="140"
                        >
                            <template #default="{intention_status, index}">
                                <div class="intention">
                                    <veui-dropdown
                                        :label="intentionStatusMap[+intention_status]?.text || '未标记'"
                                        ui="text"
                                        :options="intentionStatusOptions"
                                        @click="val => handleChangeIntention(val, index)"
                                    />
                                </div>
                            </template>
                        </veui-table-column>
                        <veui-table-column
                            key="clue_phone_num"
                            field="clue_phone_num"
                            title="手机号"
                            class="phone"
                            width="180"
                        >
                            <template #default="{clue_phone_num, is_masked}">
                                <div :class="+is_masked === 1 ? 'mask' : ''">
                                    {{ clue_phone_num || '--' }}
                                </div>
                            </template>
                        </veui-table-column>
                        <veui-table-column
                            v-if="curTab === 'myAnswer'"
                            key="dispatch_time"
                            field="dispatch_time"
                            title="认领时间"
                            class="dispatchTime"
                            width="180"
                        >
                        </veui-table-column>
                        <veui-table-column
                            v-if="curTab === 'myAnswer'"
                            key="owner_name"
                            field="owner_name"
                            title="回答成员"
                            class="dispatchTime"
                            width="180"
                        >
                            <template #default="{owner_name}">
                                {{ owner_name}}
                            </template>
                        </veui-table-column>
                        <veui-table-column
                            field="operation"
                            title="操作"
                            align="center"
                            :width="curTab === 'myAnswer' ? 240 : curTab === 'isMax' ? 132 : 190"
                            fixed="right"
                        >
                            <template #default="{ index, bind_status, clue_phone, has_received, can_claim, owner_name }">
                                <template
                                    v-if="curTab === 'localQues' || curTab === 'nationalQues'"
                                >
                                    <!-- eslint-disable -->
                                    <veui-button
                                        v-if="+can_claim === 0"
                                        ref="update"
                                        ui="text"
                                        disabled
                                        class="update"
                                        @click="() => {}"
                                    >升级会员，解锁线索</veui-button>
                                    <veui-button
                                        v-else
                                        ui="text"
                                        class="write"
                                        :class="{'gray': has_received === 1}"
                                        @click="goWrite(index, has_received)"
                                    >
                                        回复获取电话
                                    </veui-button>
                                    <veui-tooltip
                                        v-if="+can_claim === 0"
                                        target="update"
                                        position="left"
                                        overlay-class="update-tooltip"
                                        :hide-delay="10"
                                    >您当前的会员类型不可领取此线索，升级会员{{ vipInfo.vipStatusName === 'noVip' ? '可认领线索' : '获取更多权益' }}</veui-tooltip>
                                </template>
                                <veui-button
                                    v-if="curTab === 'isMax'"
                                    ui="text"
                                    disabled
                                    class="write disabled"
                                >
                                    已被领满
                                </veui-button>
                                <veui-button
                                    v-if="curTab === 'myAnswer'"
                                    ui="text"
                                    class="write"
                                    @click="goDetail(index)"
                                >
                                    查看
                                </veui-button>
                                <veui-button
                                    v-if="curTab === 'myAnswer' && isFirm"
                                    ui="text"
                                    class="write"
                                    @click="openUserDialog(index)"
                                >
                                    换人跟进
                                </veui-button>
                                <veui-button
                                    v-if="curTab === 'myAnswer'
                                        && bind_status
                                        && clue_phone
                                        && (!isFirm ||(isFirm && owner_name === '律所管理员'))"
                                    ui="text"
                                    class="write"
                                    @click="clickPhone(index)"
                                >
                                    拨打电话
                                </veui-button>
                            </template>
                        </veui-table-column>
                        <template v-if="curTab === 'nationalQues' && searchParams && cityName === searchParams.clue_city" #no-data>
                            <div class="no-data-box">
                                <div class="text">该城市的咨询内容请点击本地咨询查看</div>
                            </div>
                        </template>
                    </veui-table>
                </section>
                 <!-- 分页 -->
                <section class="pagination">
                    <veui-pagination
                        :page="page"
                        :page-size="pageSize"
                        :total="total"
                        @redirect="pageChange"
                    />
                </section>
            </div>
        </section>
        <!-- 电话弹框 -->
        <veui-dialog
            ui="narrow"
            title="您可以直接通过手机联系用户"
            :open.sync="isShowPhone"
            overlay-class="order-management-dialog"
        >
            <p>
                用户手机号码如下：{{ phoneInfo.clue_phone }}
            </p>
            <template #foot>
                <veui-button
                    ui="m primary"
                    @click="isShowPhone = false"
                >
                    我知道了
                </veui-button>
            </template>
        </veui-dialog>
        <!-- 写回答 -->
        <section v-if="isShowWriteAnswer">
            <writeAnswer
                :consume-type="consumeType"
                :quesInfo="quesInfo"
                @closeWriteCard="closeWrite"
                @submitSuccess="submitSuccess"
            />
        </section>
        <veui-dialog
            ui="narrow"
            title=""
            :open.sync="isShowNoVip"
            overlay-class="order-management-dialog"
        >
            <p>您还未开通会员，开通后即可享受公开咨询无限次认领权益，触达更多法律诉求用户。</p>
            <template #foot>
                <veui-button
                    ui="m primary"
                    @click="jumplawservice('vip-dialog-btn')"
                >
                    立即开通
                </veui-button>
            </template>
        </veui-dialog>
        <detail-modal
            :show="isDetailShow"
            :quesInfo="quesInfo"
            @close="isDetailShow = false"
        />
        <veui-dialog
            overlay-class="unband-confirm"
            title="更换跟进成员"
            :open.sync="isConfirmShow"
        >
            <p class="confirm-text">
                当前认领成员： {{ currentRecord.owner_name }}
            </p>
            <div class="lawyer-box">
                <p class="confirm-text">更换为：</p>
                <veui-select
                    v-model="newLawyerName"
                    placeholder="选择律师"
                    class="lawyer-search"
                >
                    <veui-option
                        v-for="(item, index) in lawyerList"
                        :key="index"
                        :value="item.name"
                        :label="item.name"
                    />
                </veui-select>
            </div>
            <template #foot>
                <div class="btn-box">
                    <div
                        class="btn-item"
                        @click="handleclose('isConfirmShow')"
                    >
                        取消
                    </div>
                    <div
                        class="btn-item confirm"
                        @click="confirmChange"
                    >
                        完成
                    </div>
                </div>
            </template>
        </veui-dialog>
    </div>
</template>

<script>
/**
 * @file index.vue
 * @desc 会员公开咨询
 * @author dingzhenyue@baidu.com
 */
import {
    Tabs,
    Tab,
    Table,
    Button,
    Column,
    Pagination,
    Popover,
    Dialog,
    Dropdown,
    DatePicker,
    Select,
    Option,
    Tooltip
} from 'veui';
import {mapState, mapMutations} from 'vuex';
import writeAnswer from '../components/write-answer.vue';
import searchForm from '../components/search-form.vue';
import detailModal from '../components/detail-modal.vue';
import mixinauthentice from '@/mixins/authentice';
import {pastTimeBlur} from '@/utils/util';
import dayjs from 'dayjs';
import overflowTooltip from '../../../components/overflowTooltip.vue';
import {MARK_OPTIONS, MARK_MAP} from '../../../common/index';
import freeVipBanner from '@/components/vip/free-vip-banner.vue';
import {downloadFile} from '@/utils/download';
import {expertise_area_level1} from '@/utils/domains';

export default {
    name: 'offlineQa',
    mixins: [mixinauthentice],
    components: {
        'veui-tabs': Tabs,
        'veui-tab': Tab,
        'veui-table': Table,
        'veui-button': Button,
        'veui-table-column': Column,
        'veui-dialog': Dialog,
        'veui-dropdown': Dropdown,
        'veui-pagination': Pagination,
        'veui-popover': Popover,
        'overflow-tooltip': overflowTooltip,
        writeAnswer,
        'search-form': searchForm,
        'detail-modal': detailModal,
        freeVipBanner,
        'veui-date-picker': DatePicker,
        'veui-tooltip': Tooltip,
        'veui-select': Select,
        'veui-option': Option
    },
    filters: {
        dateFilter(value) {
            if (!value) {
                return '-';
            }
            return pastTimeBlur(value);
        },
        clueFilter(status) {
            return status ? '是' : '否';
        },
        statusFilter(status) {
            let data = {
                1: '审核中',
                2: '审核通过',
                3: '审核不通过'
            };
            return data[status] || '';
        }
    },
    data() {
        return {
            // 当前选中的是哪个tab
            curTab: '',
            tableData: [],
            // 是否展示写回答
            isShowWriteAnswer: false,
            // 状态筛选
            stateOptions: [
                {
                    label: '全部',
                    value: 2
                },
                {
                    label: '是',
                    value: 1
                },
                {
                    label: '否',
                    value: 0
                }
            ],
            // 文案映射
            textMap: {
                'vip': '您当前为尊享会员，已解锁70%的线索权益',
                'eliteVip': '您当前为精英会员，已解锁50%的线索权益',
                'beginnerVip': '您当前会员类型为启航会员，已解锁20%的线索权益',
                'freeVip': '您当前为免费体验会员，已解锁对应线索权益',
                'noVip': '您当前还不是会员，开通会员可享对应权益'
            },
            // 指标数据
            indicatorsData: [
                {
                    title: '本月获取电话数',
                    num: 0,
                    tipContent:
                        '每月1日初始化清零，通过公开咨询回答问题并成功获取的电话数量',
                    firmTipContent:
                        '每月1日初始化清零，通过公开咨询回答问题并成功获取的电话数量'
                },
                {
                    title: '累计获取电话数',
                    num: 0,
                    tipContent: '指您在公开咨询通过回答并成功获取的电话数量',
                    firmTipContent: '指在公开咨询通过回答并成功获取的电话数量'
                },
                {
                    title: '本月回复咨询数',
                    num: 0,
                    tipContent:
                        '每月1日初始化清零，指您在公开咨询回答的咨询数量',
                    firmTipContent: '每月1日初始化清零，指在公开咨询回答的咨询数量'
                },
                {
                    title: '累计回复咨询数',
                    num: 0,
                    tipContent: '指您在公开咨询累计回答的咨询数量',
                    firmTipContent: '指在公开咨询累计回答的咨询数量'
                }
            ],
            intentionStatusOptions: MARK_OPTIONS.slice(1),
            areaOptions: [],
            regionOptions: [],
            intentionStatusMap: MARK_MAP,
            // 本地城市
            cityName: '',
            // 每页个数
            pageSize: 10,
            // 当前展示第几页
            page: 1,
            // 展示手机号弹窗
            isShowPhone: false,
            // 手机号信息
            phoneInfo: {},
            // 表格数据加载中
            isLoading: true,
            // 当前选中的问题信息
            quesInfo: {},
            // 筛选中的是都可领取线索状态
            clueStatus: 2,
            // 总数
            total: 0,
            // 非vip弹框
            isShowNoVip: false,
            // 查看回答
            isDetailShow: false,
            // 查询参数
            searchParams: {},
            // 提交时的时间戳作为id，确保多次请求不混乱
            submitId: 0,
            exportOpen: false, // 数据导出弹框,
            exportDateRange: null, // 数据导出时间范围
            showDomain: [], // 本地咨询tab的律师可选择领域
            //  1： 律所额度  0：会员额度
            consume: '0',
            consumeOptions: [
                {
                    label: '律所版权益',
                    value: '1'
                },
                {
                    label: '个人版权益',
                    value: '0'
                }
            ],
            hasBusinessOffqrAuth: false, // 是否被律所授权
            isConfirmShow: false, // 换人跟进弹框
            newLawyerName: '律所管理员',
            lawyerList: [], // 换人跟进的律师列表
            isChangeUser: false, // 换绑提交的锁
            isConfirmLock: false, // 换绑获取列表的锁
            currentRecord: {}, // 换人跟进的当前线索
            consumeType: '0' //  1： 律所额度  0：会员额度
        };
    },
    computed: {
        ...mapState({
            statistics: state => state.Statistics.statistics,
            userInfo: state => state.lawStore.userInfo,
            userInfoNew: state => state?.lawStore?.userInfoNew,
            vipInfo: state => state.lawStore.vipInfo,
            authenticationStatus: state => state.lawStore.authenticationStatus,
            // 律师、律所都在使用此页面
            businessId: state => state.lawStore.userInfoNew?.lawyer_info?.business_id
                || state.lawStore.userInfoNew?.law_business_info?.id || 0,
            lawyerInfo: state => state.lawStore.userInfoNew?.lawyer_info || {}
        }),
        freeVipNotification() {
            const {vipStatusName, validityEnd} = this.vipInfo;
            const remainDays = dayjs(validityEnd).diff(dayjs(), 'days');
            if (vipStatusName === 'freeVip') {
                return `您的免费体验会员还有${remainDays}天到期，请尽快使用权益~`;
            }
            return '';
        },
        userRole() {
            return this.userInfoNew && +this.userInfoNew.user_role >= 0 ? +this.userInfoNew.user_role : -1;
        },
        // 该字段为右上角切换权益类型，2：律所版权益  1：个人版权益
        userView() {
            const {user_role} = this.userInfoNew;
            const {consumeType} = this;
            return +user_role === 2 || consumeType === '1' ? '2' : '1';
        },
        // 当前律师是否是会员
        firmVip() {
            const {business_privilege_info} = this.vipInfo || {};
            return !!(business_privilege_info && business_privilege_info.is_vip);
        },
        notLimitUser() {
            const {is_old_vip} = this.vipInfo;
            const {user_role} = this.userInfoNew;
            return (+user_role === 0 && this.consumeType === '1') || (+user_role === 2 && this.firmVip) || is_old_vip;
        },
        isFirm() { // 律所
            return +this.userInfoNew?.user_role === 2;
        }
    },
    watch: {
        vipInfo: {
            handler(val) {
                if (val) {
                    this.$wywLog.addKey({
                        isVIP: +val.vipStatus
                    });
                }
            }
        },
        curTab: {
            handler(val) {
                if (val === 'localQues' && !this.notLimitUser && !this.isFirm) {
                    const domain = this.showDomain || [];
                    this.areaOptions.forEach(item => {
                        item.disabled = !domain.includes(item.value);
                    });
                }
                else {
                    this.areaOptions.forEach(item => {
                        item.disabled = false;
                    });
                }
            }
        }
    },
    mounted() {
        this.getAreaData();
        if (+this.userInfoNew.user_role === 0) {
            const {register_domains_v1 = ''} = this.userInfoNew?.lawyer_info || {};
            this.showDomain = register_domains_v1 && register_domains_v1.split('$') || [];
        }
        this.getDomain();
        this.getIndicatorsData();
        // 页面曝光打点
        this.$log
            && this.$log.send({
                type: 'show',
                value: 'pv'
            });
    },
    methods: {
        ...mapMutations({
            emitEvent: 'EventBus/emitEvent'
        }),
        // 去授权权益
        goVipSet() {
            this.$router.push({name: 'vipSet'});
        },
        // 换人更近弹框
        openUserDialog(index) {
            if (this.isConfirmLock) {
                return;
            }
            if (this.lawyerList.length > 0) {
                this.newLawyerName = '律所管理员';
                this.currentRecord = this.tableData[index];
                this.isConfirmShow = true;
                return;
            }
            this.isConfirmLock = true;
            this.currentRecord = this.tableData[index];
            const params = {
                businessId: this.businessId
            };
            this.$http
                .get('/bp/api/business/getlawyerlist', {
                    params
                })
                .then(res => {
                    const data = this.$normalizeResponseData(res);
                    if (data) {
                        let list = data.list || [];
                        list.unshift({
                            name: '律所管理员'
                        });
                        this.lawyerList = list;
                        this.count = data.count || 0;
                        this.isConfirmShow = true;
                    }
                    else {
                        this.lawyerList = [];
                        this.count = 0;
                    }
                    this.isConfirmLock = false;
                })
                .catch(err => {
                    this.$normalizeResponseError(err);
                    this.isConfirmLock = false;
                });
        },
        // 确定换人
        confirmChange() {
            if (this.isChangeUser) {
                return;
            }
            this.isChangeUser = true;
            const params = {
                mode: 'offqr',
                ori_name: this.currentRecord.owner_name,
                clue_id: this.currentRecord.clue_id,
                target_name: this.newLawyerName
            };
            this.$http
                .post('/bp/api/clue/change_clue_owner', {
                    ...params
                })
                .then(res => {
                    this.isChangeUser = false;
                    if (res.code !== '0') {
                        this.$normalizeResponseError(res.msg);
                        return;
                    }
                    this.$Message.success('已成功换绑成员跟进');
                    this.getReplyList();
                })
                .catch(err => {
                    this.$normalizeResponseError(err);
                    this.isChangeUser = false;
                });
            this.handleclose('isConfirmShow');
        },
        // 取消换人弹框
        hideConfirm() {
            this.isConfirmShow = false;
        },
        handleclose(type) {
            this[type] = false;
        },
        /**
         * 修改权益使用（个人/律所）
         */
        changeConsumeType(value) {
            this.consumeType = value;
            if (this.curTab === 'localQues' || this.curTab === 'nationalQues') {
                this.getDomain();
                this.getQuestionList();
            }
            if (this.curTab === 'myAnswer') {
                this.getReplyList();
                return;
            }
        },
        /**
         * 处理导出数据
         */
        handleExport() {
            if (this.exportDateRange && this.exportDateRange[0] && this.exportDateRange[1]) {
                this.exportDateRange_start = (
                    +this.exportDateRange[0] / 1000
                ).toFixed(0);
                this.exportDateRange_end = +((+this.exportDateRange[1] / 1000).toFixed(0)) + 86399;
            };
            const text = dayjs(new Date()).format('YYYYMMDD_HHmm');
            this.exportDateRange = null;
            if (this.exportDateRange_start && this.exportDateRange_end) {
                downloadFile(
                    `/bp/api/offqr/reply_list_export?begin_ts=${this.exportDateRange_start}`
                        + `&end_ts=${this.exportDateRange_end}&view=${this.userView}`,
                    `我的回答导出-${text}.csv`
                );
                // 初始化开始结束时间
                this.exportDateRange_start = null;
                this.exportDateRange_end = null;
                // 关闭弹窗
                this.exportOpen = false;
                this.$toast.success('数据导出成功');
            }
            else {
                this.exportOpen = true;
                this.$toast.error('请选择正确的时间范围');
            }
        },
        /**
         * 判断时间是否可选
         */
        checkDateDisable(date, oldDate) {
            const startDate = oldDate && dayjs(oldDate).subtract(90, 'day');
            const endDate = oldDate && dayjs(oldDate).add(90, 'day') || dayjs(new Date());
            // 只可选择一个季度范围之内的数据进行导出，并且关注时间不能超过当前时间
            if (date && dayjs(date) > startDate && dayjs(date) < endDate && dayjs(date) < dayjs(new Date())) {
                return false;
            }
            return true;
        },
        /**
         * 关闭弹窗
         */
        handleCancel() {
            this.exportOpen = false;
            this.exportDateRange = null;
        },
        /**
         * 跳转
         */
        goto(url) {
            this.$router.push({name: url});
        },

        /**
         * 切换tab操作
         */

        tabChange(tab) {
            // 重复点击同一tab
            if (tab?.name === this.curTab) {
                return;
            }
            this.$refs['search-form']?.handleReset();
            tab?.name
                && this.$wywLog.send({
                    serverId: 16854,
                    area: tab.name,
                    action: 'show'
                });
            this.page = 1;
            this.curTab = tab?.name || this.curTab;
            // tab点击打点
            this.$log
                && this.$log.send({
                    type: 'clk',
                    value: 'tab-change',
                    ext: {
                        tab: this.curTab
                    }
                });
        },

        /**
         * 去写答案
         */

        goWrite(index, has_received) {
            if (has_received) {
                this.$Message.error('您已认领该线索，请选择其他线索');
                return;
            }
            const {privilege_info, vipStatus} = this.vipInfo;
            // 非会员
            if (!+vipStatus && this.userView === '1') {
                // 体验会员过期用户
                if (privilege_info && +privilege_info.vip_code_type === 6) {
                    this.emitEvent({name: 'global_free_vip_event', payload: {
                        dialogType: 'expire-no-avatar',
                        expireKeywords: '公开咨询抢答'
                    }});
                    return;
                }
                this.isShowNoVip = true;
                return;
            }
            this.quesInfo = this.tableData[index] || {};
            this.isShowWriteAnswer = true;
            this.$wywLog.send({
                serverId: 16854,
                area: `${this.curTab}-reply`,
                action: 'click'
            });
            // 写回答打点
            this.$log
                && this.$log.send({
                    type: 'clk',
                    value: 'write-answer'
                });
        },

        /**
         * 线索筛选状态改变
         */

        stateChange(data) {
            this.$log
                && this.$log.send({
                    type: 'clk',
                    value: 'state-change',
                    ext: {
                        tab: this.curTab,
                        status: data
                    }
                });
            this.clueStatus = +data;
            // 刷新表格
            this.page = 1;
            this.refresh();
        },

        /**
         * 更改标记
         * @param {String} value 标记值
         * @param {Number} index
         */
        handleChangeIntention(value, index) {
            const {reply_id} = this.tableData[index] || {};
            if (reply_id) {
                this.$wywLog.send({
                    serverId: 16854,
                    area: `${this.curTab}-intention`,
                    action: 'click',
                    intention_status: value
                });
                this.$http
                    .post('/bp/api/offqr/edit_intention', {
                        reply_id,
                        view: this.userView,
                        intention_status: value
                    })
                    .then(res => {
                        if (+res?.code === 0) {
                            this.$set(
                                this.tableData[index],
                                'intention_status',
                                value
                            );
                        }
                        else {
                            this.$normalizeResponseError(res);
                        }
                    });
            }
        },

        /**
         * 打开问题详情
         * @param {Number} index
         */

        goDetail(index) {
            this.quesInfo = this.tableData[index] || {};
            this.isDetailShow = true;
        },

        /**
         * 获取我的回答列表
         */

        getReplyList() {
            const currentSubmitId = this.submitId;
            this.isLoading = true;
            let params = {
                pn: this.page,
                rn: this.pageSize,
                view: this.userView,
                ...this.searchParams
            };
            if (+this.clueStatus !== 2) {
                params = {
                    ...params,
                    type: this.clueStatus
                };
            }
            this.$http
                .get('/bp/api/offqr/reply_list', {
                    params
                })
                .then(res => {
                    // 非最新查询请求，不渲染数据
                    if (currentSubmitId !== this.submitId) {
                        return;
                    }
                    res = this.$normalizeResponseData(res);
                    this.tableData = res?.list || [];
                    this.total = res?.total || 0;
                })
                .catch(err => {
                    this.$normalizeResponseError(err);
                })
                .finally(() => {
                    if (currentSubmitId !== this.submitId) {
                        return;
                    }
                    this.isLoading = false;
                });
        },

        /**
         * 获取问题广场列表
         */

        getQuestionList() {
            const currentSubmitId = this.submitId;
            this.isLoading = true;
            this.$http
                .get('/bp/api/offqr/ques_list', {
                    params: {
                        pn: this.page,
                        rn: this.pageSize,
                        view: this.userView,
                        mode: this.curTab === 'localQues' ? 4 : this.curTab === 'nationalQues' ? 2 : 3,
                        ...this.searchParams
                    }
                })
                .then(res => {
                    // 非最新查询请求，不渲染数据
                    if (currentSubmitId !== this.submitId) {
                        return;
                    }
                    res = this.$normalizeResponseData(res);
                    this.tableData = res?.list || [];
                    this.total = res?.total || 0;
                })
                .catch(err => {
                    this.$normalizeResponseError(err);
                })
                .finally(() => {
                    if (currentSubmitId !== this.submitId) {
                        return;
                    }
                    this.isLoading = false;
                });
        },

        /**
         * 点击拨打电话，展示弹框
         */

        clickPhone(index) {
            this.$wywLog.send({
                serverId: 16854,
                area: `${this.curTab}-phone`,
                action: 'click'
            });
            // 点击拨打电话打点
            this.$log
                && this.$log.send({
                    type: 'clk',
                    value: 'call-phone'
                });
            let phoneInfo = this.tableData[index] || {};
            this.phoneInfo = phoneInfo;
            if (phoneInfo.clue_phone) {
                this.isShowPhone = true;
            }
        },

        /**
         * 获取指标数据
         */
        getIndicatorsData() {
            this.$http
                .get('/bp/api/vip/offqr_index', {})
                .then(res => {
                    res = this.$normalizeResponseData(res);
                    let {
                        business_month_received,
                        business_month_reply,
                        business_received,
                        business_reply,
                        person_month_received,
                        person_month_reply,
                        person_received,
                        person_reply
                    } = res?.user_info?.received || {};
                    let has_business_offqr_auth = res?.user_info?.has_business_offqr_auth || false;
                    this.hasBusinessOffqrAuth = has_business_offqr_auth;
                    let indicatorsData = [...this.indicatorsData];
                    indicatorsData[0].num = {
                        business_num: business_month_received,
                        person_num: person_month_received
                    };
                    indicatorsData[1].num = {
                        business_num: business_received,
                        person_num: person_received
                    };
                    indicatorsData[2].num = {
                        business_num: business_month_reply,
                        person_num: person_month_reply
                    };
                    indicatorsData[3].num = {
                        business_num: business_reply,
                        person_num: person_reply
                    };
                    this.indicatorsData = indicatorsData;
                    if (this.curTab === 'localQues' || !this.curTab) {
                        this.tabChange({name: 'localQues'});
                    }
                })
                .catch(err => {
                    this.$normalizeResponseError(err);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        getAreaData() {
            this.$http
                .get('/bp/api/vip/claim_clue_index', {
                    params: {
                        user_type: this.userInfoNew.user_role
                    }
                })
                .then(response => {
                    if (+response.code === 0 && response.data) {
                        const respData = response.data;
                        this.cityName = respData.user_info?.cityName;
                    }
                })
                .catch(err => {
                    this.$normalizeResponseError(err);
                });
        },
        getDomain() {
            const domain = this.showDomain || [];
            if (!this.notLimitUser && !this.isFirm) {
                this.areaOptions = expertise_area_level1.map(item => ({
                    label: item.text,
                    // 默认为本地咨询的tab，并且在本地咨询tab下的领域，若非律师自己对应的领域(showDomain), 则领域选项置灰
                    // 该策略仅用于新会员
                    ...item,
                    disabled: !domain.includes(item.value)
                }));
            }
            else {
                this.areaOptions = expertise_area_level1.map(item => ({
                    label: item.text,
                    // 默认为本地咨询的tab，并且在本地咨询tab下的领域，若非律师自己对应的领域(showDomain), 则领域选项置灰
                    // 该策略仅用于新会员
                    ...item
                }));
            }
        },
        pageChange(e) {
            this.page = e;
            this.refresh();
        },

        handleSubmit(e) {
            // 最新一次查询id
            this.submitId = Date.now();
            this.searchParams = e;
            this.page = 1;
            this.refresh();
        },

        /**
         * 刷新页面
         */
        refresh() {
            if (this.curTab === 'myAnswer') {
                this.getReplyList();
                return;
            }
            this.getQuestionList();
        },

        /**
         * 关闭回答页面
         */

        closeWrite() {
            this.isShowWriteAnswer = false;
            this.refresh();
        },

        /**
         * 回答提交成功
         */

        submitSuccess() {
            this.curTab = 'myAnswer';
            this.page = 1;
            this.closeWrite();
        },

        /**
         * 成为会员
         */
        jumplawservice(area) {
            area
                && this.$wywLog.send({
                    serverId: 16854,
                    area,
                    action: 'click'
                });
            this.$router.push({name: 'lawservice'});
        }
    }
};
</script>

<style lang='less' scoped>
@import "../../../assets/css/law-table.less";

.export-dialog {
    /deep/.veui-dialog-content {
        width: 350px !important;
    }

    .veui-date-picker {
        margin-top: 10px;
    }
}

.update-tooltip {
    /deep/.veui-tooltip {
        background-color: rgba(0, 0, 0, .7);
        color: white;
    }

    /deep/ .veui-tooltip-arrow {
        color: rgba(0, 0, 0, .7);
    }
}

.box {
    background: #fff;
    box-shadow: 0 6px 14px 0 rgba(227, 233, 237, .35);
    border-radius: 8px;
    padding: 32px 30px 30px;

    .tip {
        display: inline-block;
        vertical-align: middle;
        margin-left: 4px;
    }
}

.offline-qa {
    height: 100%;

    section {
        height: 100%;
    }

    .indicators {
        .main-title {
            width: 100%;
            display: flex;
            align-items: center;
            font-family: PingFangSC-Semibold;
            font-size: 16px;
            color: #333;
            line-height: 16px;
            font-weight: 600;
            padding-bottom: 24px;
            position: relative;

            .vip-set {
                font-size: 16px;
                color: #3e4cff;
                position: absolute;
                padding-right: 15px;
                cursor: pointer;
                top: 0;
                right: 0;
                &::after {
                    content: '';
                    position: absolute;
                    width: 18px;
                    height: 16px;
                    background: url('https://lvlin-base.cdn.bcebos.com/bend/icon-down.png') no-repeat;
                    background-size: cover;
                    top: 0px;
                    margin-left: 6px;
                    transform: rotate(270deg);
                }
            }
        }

        .tip {
            margin-left: 6px;
            height: 14px;
            width: 14px;
            cursor: pointer;

            img {
                height: 100%;
                width: 100%;
            }
        }

        .vip-notification,
        .noVip-notification {
            margin-left: 10px;
            display: flex;
            align-items: center;
            padding: 0 8px;
            height: 16px;
            // background: rgba(226, 116, 4, 0.1);
            background-image: linear-gradient(90deg, #ffe99e 1%, #ffdc68 100%);
            border-radius: 8px;
            font-family: PingFangSC-Regular;
            font-size: 10px;
            color: #9a490e;
            font-weight: 400;

            .icon-more {
                width: 9px;
                height: 9px;
                background: url(https://lvlin-base.cdn.bcebos.com/fe-saas/page/offline-qa/icon-more.png)
                    no-repeat center/cover;
            }
        }

        .noVip-notification {
            cursor: pointer;
        }

        .free-vip-notification {
            margin-left: 6px;
            height: 20px;
            padding: 0 8px;
            display: inline-flex;
            align-items: center;
            background-image: linear-gradient(90deg, #ffe99e 1%, #ffdc68 100%);
            border-radius: 2px;
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: #9a490e;
            font-weight: 400;

            &::before {
                content: "";
                background: url("https://lvlin-base.cdn.bcebos.com/fe-saas/component/free-membership/icon-notification.png")
                    no-repeat center / cover;
                width: 14px;
                height: 14px;
                margin-right: 6px;
            }
        }

        .indicators-wrap {
            display: flex;
            justify-content: space-between;
            border-radius: 8px;
            background: linear-gradient(90deg, rgba(231, 238, 255, .4) 30%, rgba(224, 230, 247, .4) 100%);

            .item {
                position: relative;
                flex: 1;
                display: flex;
                justify-content: center;
                padding-top: 30px;
                padding-bottom: 30px;

                &:not(:last-child) {
                    &::after {
                        content: "";
                        display: block;
                        width: 1px;
                        height: 48px;
                        background-color: rgba(51, 51, 51, .09);
                        position: absolute;
                        top: 30px;
                        right: 0;
                    }
                }

                .title {
                    font-family: PingFangSC-Regular;
                    font-size: 14px;
                    color: #333;
                    line-height: 14px;
                    font-weight: 400;
                    display: flex;
                }

                .num {
                    font-family: HelveticaNeue-Bold;
                    font-size: 28px;
                    color: #282c33;
                    line-height: 28px;
                    font-weight: 700;
                    padding-top: 9px;
                }
            }
        }

        .clue-select {
            float: right;
            position: absolute;
            top: 0;
            right: 0;
            font-size: 14px;
            font-weight: 400;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            .clue-select-text {
                .prompt {
                    width: 10px;
                    height: 10px;
                    display: inline-block;
                    margin-right: 10px;
                }
                padding: 3px 8px;
                background: #FFD2A9;
                display: flex;
                align-items: center;
                border-radius: 8px;
                font-family: PingFang SC;
                font-size: 10px;
                line-height: 1;
                color: #A54300;
            }
        }

        .select {
            width: 120px;
            margin-left: 8px;
        }
    }

    .content {
        margin-top: 24px;
        padding-top: 6px;

        .pagination {
            text-align: right;
            margin-top: 12px;
        }

        .table-section {
            position: relative;

            .export-btn {
                position: absolute;
                right: 16px;
                top: -65px;
                height: 40px;
                display: flex;
                align-items: center;
                color: #05f;
                font-size: 16px;
                font-family: PingFangSC-Medium;
                cursor: pointer;

                .export-icon {
                    margin-right: 4px;
                    width: 15px;
                    height: 16.25px;
                    background: url(https://lvlin-base.cdn.bcebos.com/fe-saas/page/offline-qa/export.png) no-repeat center center / 100% 100%;
                }
            }
        }

        /deep/ .veui-tabs-menu {
            .veui-tabs-item {
                margin: 0 31px;

                &:first-child {
                    margin-left: 0;
                }
            }

            .veui-tabs-item-label {
                font-family: PingFangSC-Medium;
                font-size: 16px;
                line-height: 16px;
                font-weight: 500;
            }
        }
    }

    .table {
        margin-top: 8px;

        .write:not(.veui-disabled) {
            color: #05f;
        }

        .gray:not(.veui-disabled) {
            color: #ccc;
        }

        /deep/ .veui-table-cell {
            .veui-table-cell-content {
                width: 100%;

                .mask {
                    filter: blur(3px);
                }

                .veui-button {
                    font-size: 16px;
                }

                .update {
                    font-size: 16px;
                    color: #a54300;
                    font-family: PingFangSC-Medium;
                }
            }

            .title {
                font-size: 16px;
                color: #333;
                line-height: 26px;
                font-weight: 500;
                white-space: break-spaces;
                word-break: break-all;
                overflow: hidden; // 溢出内容隐藏
                text-overflow: ellipsis; // 文本溢出部分用省略号表示
                display: -webkit-box; // 特别显示模式
                -webkit-line-clamp: 2; // 行数
                line-clamp: 2;
                -webkit-box-orient: vertical; // 盒子中内容竖直排列
                max-width: 608px;
            }

            .date {
                font-family: PingFangSC-Regular;
                font-size: 14px;
                color: #999;
                line-height: 14px;
                font-weight: 400;
                margin-top: 19px;
            }

            .territory-tags {
                display: flex;
                align-items: center;
                flex-wrap: wrap;
                margin-top: -8px;

                .territory-tag {
                    padding: 0 8px;
                    height: 20px;
                    border-radius: 10px;
                    background: rgba(233, 236, 243, .5);
                    font-family: PingFangSC-Regular;
                    font-size: 14px;
                    color: #999;
                    line-height: 20px;
                    font-weight: 400;
                    margin-right: 12px;
                    margin-top: 8px;
                }
            }

            .operation {
                padding: 0 24px;
            }
        }
    }

    /deep/.veui-table [role="columnheader"] {
        padding: 12px 16px;
    }
}

.unband-confirm {
    /deep/ .veui-dialog-content {
        width: 420px;
    }

    /deep/ .veui-input {
        height: 32px;
    }

    .confirm-text {
        height: 24px;
        line-height: 24px;
        color: #000;
    }

    .lawyer-box {
        display: flex;
        align-items: center;
        margin: 18px 0 12px;

        .lawyer-search {
            width: 298px;
        }
    }

    .confirm-tip {
        color: #999;
        line-height: 22px;
    }

    .btn-box {
        display: flex;
        align-items: center;
        justify-content: center;

        .btn-item {
            border: 1px solid rgba(56, 85, 213, 1);
            border-radius: 5px;
            padding: 10px 29px;
            font-size: 14px;
            color: #3855d5;
            cursor: pointer;
        }

        .confirm {
            background: #3855d5;
            color: #fff;
            margin-left: 24px;
        }
    }
}

.intention {
    .badge {
        display: inline-block;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        margin-right: 6px;
    }
}

.veui-overlay-box.vip-guide {
    .veui-dialog-content-body {
        height: 700px;

        .content {
            height: 100%;
            overflow: auto;

            img {
                width: 395px;
                height: auto;
            }
        }
    }
}
</style>